export class EmailQuoteData {
    primaryEmail: string;
    comment: string;

    constructor() {
        this.comment = null;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/email-quote/models/email-quote-data.model.ts